import { forwardRef, memo, type ReactNode, type Component } from 'react';
import clsx from 'clsx';
// Material UI imports
import Box, { type BoxProps } from '@mui/material/Box';
// local imports
import ScrollToTopOnMount from '../common/ScrollToTopOnMount';
import { type AppBarVariant, APPBAR_NONE } from '../elements/AppBar';
import Copyright from '../elements/Copyright';
// Media and SCSS imports
import Diamonds from '../images/welcome.svg?react';
import { main, mainFrame, mainSplash, gradient, gradientOnly, height99vh, toolbar, diamonds } from './AppScreen.module.scss';

type AppScreenProps = {
  readonly children?: ReactNode;
  readonly splash?: boolean;
  readonly fullHeight?: boolean;
  readonly frame?: boolean;
  readonly dashboard?: boolean;
  readonly appbar?: AppBarVariant;
  readonly header?: ReactNode;
  readonly footer?: ReactNode;
  readonly className?: string;
};

const AppScreen = forwardRef<Component<BoxProps>, AppScreenProps>(({
  children,
  splash = false,
  fullHeight = false,
  frame = false,
  dashboard = false,
  appbar = 'full',
  header,
  footer,
  className
}, ref) => (
  <Box
      ref={ref}
      display="flex"
      flexGrow={1}
      flexDirection="column"
      bgcolor={dashboard && fullHeight ? undefined : 'background.default'}
      className={dashboard && fullHeight ? gradientOnly : undefined}
  >
    <ScrollToTopOnMount/>
    {appbar !== APPBAR_NONE && header}
    <main
        className={clsx(className, {
          [mainSplash]: splash,
          [mainFrame]: frame,
          [main]: !splash && !frame,
          [height99vh]: fullHeight,
          [gradient]: dashboard && !fullHeight
        })}
    >
      {appbar !== APPBAR_NONE && <div className={toolbar}/>}
      {splash ? <Diamonds className={diamonds}/> : undefined}
      {children}
    </main>
    {footer}
    {frame ? undefined : <Copyright mb={fullHeight ? 1.5 : undefined}/>}
  </Box>
));

AppScreen.displayName = 'AppScreen';

export default memo(AppScreen);
